.group {
  display: inline-flex;
  border-radius: var(--tuna-shape-borderRadius);
}

.groupVertical {
  flex-direction: column;
}

.toggleButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 1px solid var(--tuna-palette-divider);
  background: none;
  color: var(--tuna-palette-text-secondary);
  cursor: pointer;
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-button-fontSize);
  text-transform: none;
  padding: 8px 12px;
  transition:
    background-color var(--tuna-transitions-duration-short) var(--tuna-transitions-easing-easeInOut),
    color var(--tuna-transitions-duration-short) var(--tuna-transitions-easing-easeInOut);
}

.toggleButton:hover {
  background: var(--tuna-palette-action-hover);
}

.toggleButton:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: -2px;
  z-index: 1;
}

.selected {
  color: var(--tuna-palette-primary-main);
  background: color-mix(in srgb, var(--tuna-palette-primary-main) 12%, transparent);
}

.selected:hover {
  background: color-mix(in srgb, var(--tuna-palette-primary-main) 20%, transparent);
}

.small {
  padding: 4px 8px;
  font-size: 0.8125rem;
}

.large {
  padding: 12px 16px;
}

.toggleButton:disabled {
  opacity: 0.38;
  pointer-events: none;
}

/* Collapsed borders within group */
.group > .toggleButton:not(:first-child) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.group > .toggleButton:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.groupVertical > .toggleButton:not(:first-child) {
  margin-left: 0;
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: var(--tuna-shape-borderRadius);
}

.groupVertical > .toggleButton:not(:last-child) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-right-radius: var(--tuna-shape-borderRadius);
}
